import script from "./PositionTrackerIosButton.vue?vue&type=script&setup=true&lang=js"
export * from "./PositionTrackerIosButton.vue?vue&type=script&setup=true&lang=js"

import "./PositionTrackerIosButton.vue?vue&type=style&index=0&id=5ae381d4&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5ae381d4"]])

export default __exports__